export default "__VITE_ASSET__CEtupMKc__"